import { GoogleOAuthProvider } from '@react-oauth/google';
import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App.jsx';
import store from './app/store';

const root = ReactDOM.createRoot(document.getElementById('root'));

// TODO: add exhaustive configuration
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DNS,
  sendDefaultPii: true,
  environment: import.meta.env.VITE_NODE_ENV,
});

root.render(
  <Provider store={store}>
    <GoogleOAuthProvider clientId={import.meta.env.VITE_API_GOOGLE_CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  </Provider>
);
